export enum profilePaths {
  INDEX = '/',
  SECYURITY = '/security',
  REPORT = '/report'
}
